const footerItems = [
  {
    title: "Product",
    links: [
      {
        text: "Features",
        link: "/#features"
      },
      {
        text: "Pricing",
        link: "/#pricing"
      },
      {
        text: "FAQ",
        link: "/#faq"
      }
    ]
  },
    {
    title: "Company",
    links: [
      {
        text: "Legal",
        link: "#"
      },
      {
        text: "Media Kit",
        link: "#"
      },
      {
        text: "Blog",
        link: "/blog"
      }
    ]
  },
  {
    title: "Socials",
    links: [
      {
        text: "Discord",
        link: "https://discord.com/invite/XFGUFVDbUh"
      },
      {
        text: "Twitter",
        link: "https://x.com/getrefray"
      },
      {
        text: "Email",
        link: "mailto:contact@refray.io"
      }
    ]
  }
]

export default function Footer() {
  return (
    <footer className="py-12 md:mx-20 grid md:grid-cols-4 gap-8 text-center md:text-right text-white">
      <div className="lowercase text-3xl md:text-left">refray</div>
      {
        footerItems.map((item, i) => (
          <div key={i} className="space-y-2 text-xl">
            <div className="text-white opacity-50 mb-2">{item.title}</div>
            {item.links.map((link, j) => (
              <a key={j} href={link.link} className="block hover:opacity-80 transition">{link.text}</a>
            ))}
          </div>
        ))
      }

    </footer>
  );
}
